import styled from 'styled-components'
import { SeverityLevel } from '../../../types/API'

const severityColors: Record<SeverityLevel, { bg: string; text: string; border: string }> = {
  [SeverityLevel.CRITICAL]: { bg: 'rgba(255, 68, 68, 0.1)', text: '#ff4444', border: 'rgba(255, 68, 68, 0.25)' },
  [SeverityLevel.HIGH]:     { bg: 'rgba(255, 150, 50, 0.1)', text: '#ff8c32', border: 'rgba(255, 150, 50, 0.25)' },
  [SeverityLevel.MEDIUM]:   { bg: 'rgba(255, 204, 51, 0.1)', text: '#FFCC33', border: 'rgba(255, 204, 51, 0.25)' },
  [SeverityLevel.LOW]:      { bg: 'rgba(111, 92, 230, 0.1)', text: '#a89aff', border: 'rgba(111, 92, 230, 0.25)' },
  [SeverityLevel.INFORMATIONAL]: { bg: 'rgba(255,255,255,0.05)', text: '#555', border: 'rgba(255,255,255,0.08)' },
}

export const Card = styled.div`
  background: #161616;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 8px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
`

export const Title = styled.div`
  color: #ededed;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
  flex: 1;
`

export const CloseButton = styled.button`
  background: transparent;
  border: 0;
  color: #a1a1a1;
  font-size: 16px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  transition: color 0.15s;
  flex-shrink: 0;

  &:hover { color: #a0a0a0; }
`

export const Description = styled.p`
  color: #777;
  font-size: 12px;
  line-height: 1.6;
  margin: 0;
`

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-top: 2px;
`

export const Timestamp = styled.span`
  color: #777;
  font-size: 11px;
  font-family: 'SF Mono', 'Fira Code', monospace;
`

export const SeverityPill = styled.span<{ severity: SeverityLevel }>`
  background: ${({ severity }) => severityColors[severity]?.bg || 'rgba(255,255,255,0.05)'};
  color: ${({ severity }) => severityColors[severity]?.text || '#555'};
  border: 1px solid ${({ severity }) => severityColors[severity]?.border || 'rgba(255,255,255,0.08)'};
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 2px 7px;
  border-radius: 4px;
  white-space: nowrap;
`
